import { createFileRoute } from "@tanstack/react-router";

import { CartPage } from "@/features/my/cart/cart-page";

export const Route = createFileRoute("/(member)/(protected)/my/cart")({
  component: CartPage,
});
